module.exports = __webpack_public_path__ + "img/1556063626.41a177e7.jpg";